export const selectQuoteProductReducer = (state, action) => {
  const { product } = action.payload;
  state.selectedQuoteProduct.value = product;
};

export const selectQuoteReducer = (state, action) => {
  const { quote } = action.payload;
  state.selectedQuote.value = quote;
};

export const selectQuoteItemReducer = (state, action) => {
  state.selectedQuoteItem.value = action.payload;
};

export const setQuoteFilterSelectedStatusesReducer = (state, action) => {
  const { statuses } = action.payload;
  state.quoteFilter.selectedStatuses = statuses;
};

export const setQuoteFilterSelectedOrganizationsReducer = (state, action) => {
  const { organizations } = action.payload;
  state.quoteFilter.selectedOrganizations = organizations;
};

export const setQuoteFilterCreatedByMeReducer = (state, action) => {
  const { createdByMe } = action.payload;
  state.quoteFilter.createdByMe = createdByMe;
};

export const setQuoteSortReducer = (state, action) => {
  const { quoteSort } = action.payload;
  state.quoteSort = quoteSort;
};

export const setReconciliationReducer = (state, action) => {
  const { propertyId, id, payload } = action.payload;

  const propertyData = state.propertyQuotes.value[propertyId];
  if (!propertyData || !propertyData.quotes) return;

  const quoteIndex = propertyData.quotes.findIndex((quote) => quote.id === id);
  if (quoteIndex === -1) return;

  const existingReconciliation = propertyData.quotes[quoteIndex].reconciliation || {};
  propertyData.quotes[quoteIndex].reconciliation = {
    ...existingReconciliation,
    ...payload,
  };
};

export const setContributionReducer = (state, action) => {
  const { propertyId, id, payload } = action.payload;

  const propertyData = state.propertyQuotes.value[propertyId];
  if (!propertyData || !propertyData.contributions) return;

  const quoteIndex = propertyData.contributions.findIndex((contribution) => contribution.id === id);
  if (quoteIndex === -1) return;

  const existingContribution = propertyData.contributions[quoteIndex] || {};
  propertyData.contributions[quoteIndex] = {
    ...existingContribution,
    ...payload,
  };
};
